<template lang="pug">
  .folleto-a

    h1 {{ c[0].text }}
    h2 {{ c[1].text }}
    .fo {{ c[2].text }}
    .mujeres

      .izq
        img(:src="c[4].url")

      .derecha          
        .dato
          .barra(:style="barra1")
          p {{ c[5].text.slice(0,2) + "&nbsp;" + c[5].text.slice(2,5) }}
          p {{ c[6].text }}
        .dato          
          .barra(:style="barra2")
          p {{ c[7].text.slice(0,2) + "&nbsp;" + c[7].text.slice(2,5) }}
          p {{ c[8].text }}
        .dato
          .barra(:style="barra3")
          p {{ c[9].text.slice(0,2) + "&nbsp;" + c[9].text.slice(2,5) }}
          p {{ c[10].text }}
        .dato
          .barra(:style="barra4")
          p {{ c[11].text.slice(0,2) + "&nbsp;" + c[11].text.slice(2,5) }}
          p {{ c[12].text }}
      

    .dos-col
      .mapa
        img(:src="c[13].url")
        .datos
          p {{ c[14].text }}

          span {{ c[15].text }}
          span.bck {{ c[16].text }}
          br
          span {{ c[17].text }}
          span.bck {{ c[18].text }}
          br
          span {{ c[19].text }}
          span.bck {{ c[20].text }}
          br
          span {{ c[21].text }}
          span.bck {{ c[22].text }}

      .feminicidios
        p {{ c[23].text }}
        p {{ c[24].text }}
        p {{ c[25].text }}

    .cuarentena
      p {{ c[26].text }}
      p {{ c[27].text }}

    .tarjetas

      .reloj
        img(:src="c[28].url")
        p {{ c[29].text }}
        p {{ c[30].text }}

      .papeles
        img(:src="c[31].url")
        p {{ c[32].text }}
        p {{ c[33].text }}
        p {{ c[34].text }}
        p {{ c[35].text }}
      
      .unocinco.red
        .b
          .casos {{ c[36].text }}
          .fecha {{ c[37].text }}
          .barra(:style="barra5")
        
        .b
          .casos {{ c[38].text }}
          .fecha {{ c[39].text }}
          .barra(:style="barra6")
        
        p {{ c[40].text }}
        
      .intraf.red
        .b
          .casos {{ c[41].text }}
          .fecha {{ c[42].text }}
          .barra(:style="barra7")
        
        .b
          .casos {{ c[43].text }}
          .fecha {{ c[44].text }}
          .barra(:style="barra8")
        
        p {{ c[45].text }}
      
    .pie 
      
      .notas  
        p {{ c[46].text }}
        p {{ c[47].text }}
        p {{ c[48].text }}
      
      img(:src="c[49].url")  

</template>
<script>
  export default {
    name: 'Folleto1',
    data() {
      return {
        c: {},
        barra1 : undefined,
        barra2 : undefined,
        barra3 : undefined,
        barra4 : undefined,
        barra5 : undefined,
        barra6 : undefined,
        barra7 : undefined,
        barra8 : undefined
      }
    },
    methods: {
        getContent () {
        this.$prismic.client.getByUID("folleto", "folleto1")
          .then(response => {
            this.c = response.data.contenido
            var base = this.c[5].text
            this.barra1 = 'width:' +  base / base * 100 + "%"
            this.barra2 = 'width:' +  this.c[7].text / base * 100 + "%"
            this.barra3 = 'width:' +  this.c[9].text / base * 100 + "%"
            this.barra4 = 'width:' +  this.c[11].text / base * 100 + "%"
            this.barra5 = 'height:' +  this.c[36].text / this.c[38].text * 100 + "%; width: 45%"
            this.barra6 = 'height:' +  this.c[38].text / this.c[38].text * 100 + "%; width: 45%"
            this.barra7 = 'height:' +  this.c[41].text / this.c[43].text * 100 + "%; width: 45%"
            this.barra8 = 'height:' +  this.c[43].text / this.c[43].text * 100 + "%; width: 45%"
          });
        }
    },
    created() {
        this.getContent();
    }
  }
</script>
<style scoped>
  @import url('https://fonts.googleapis.com/css2?family=Oswald:wght@500&display=swap');
</style>
<style lang="sass" scoped>


.folleto-a 
  background: #690088
  padding: 60px 2vw
  position: relative
  border-radius: 16px
  color: white

h1 
  font-family: 'Oswald', sans-serif
  font-size: calc(2em + 1vw)
  text-align: center
  margin-bottom: 10px
  line-height: 1.2em

@supports (-webkit-text-stroke: 1px #FFE500) 
  h1 
    -webkit-text-stroke: 1px #FFE500
    -webkit-text-fill-color: #690088
  
h2, .fo 
  text-align: center
h2 
  font-size: calc(1.1em + 1vw)
.fo
  margin-bottom: 2em
  
.barra
  background: white


.mujeres
  display: grid
  grid-template-columns: auto 73%
  .izq
    text-align: right
    img 
      max-width: 100%
  .derecha
    display: grid
    grid-template-rows: 1fr 1fr 1fr 1fr
    grid-template-columns: 1fr
    p 
      font-size: calc(0.4em + 1vw)
      padding-left: 5px
      margin: 0 0 .2em
    .dato 
      display: grid
      grid-template-rows: minmax(1.5fr, 1.5em) 1fr
      .barra 
        grid-row: 1
        grid-column: 1
      p:nth-child(2)
        grid-row: 1
        grid-column: 1
        color: #340043
        font-weight: bold
        align-self: end
      p:nth-child(3)
        grid-row: 2
        grid-column: 1    

      
.dos-col
  box-sizing: border-box
  display: grid
  grid-template-columns:  repeat( auto-fit , minmax(320px, 1fr) )
  column-gap: 1ch
  row-gap: 1ch
  margin-top: 2em
  & > div 
    // min-width: 340px
    // max-width: 556px
    justify-self: stretch
  .mapa 
    display: grid
    grid-template-columns: 41% 59%
    align-items: center
    border: 2px solid white
    padding: 2vw
    img 
      max-width: 100%
    .datos
      text-align: right
      p 
        font-family: 'Oswald', sans-serif
        font-weight: bold
        font-size: 1.2em
        color: #FFD600
      span:nth-child(3)
        background-color: white
      span:nth-child(6)
        background-color: #FFF3C1
      span:nth-child(9)
        background-color: #FFE86B
      span:nth-child(12)
        background-color: #FFD500
      .bck
        color: black
  .feminicidios
    background-color: #340043
    color: #FFD600
    text-align: center
    display: flex
    justify-content: center
    flex-direction: column
    margin: 0 min(2vw, 1em)
    padding: 1em
    p:nth-child(1)
      font-size: min(21vw, 8em)
      line-height: 0.8em
      margin: 0
      font-weight: 900
    p:nth-child(2)
      font-weight: 500
      font-size: min(7.5vw, 2em)
      margin: 10px 0
    p:nth-child(3)
      font-size: min(7.5vw, 1.4em)
      margin: 8px 0
.cuarentena
  text-align: right
  margin-top: min(2vw, 1em)
  p 
    font-family: 'Oswald', sans-serif
    letter-spacing: .1em
    margin: 0
    font-style: italic
  p:nth-child(1)
    font-size: min(2em, 6.5vw)
    line-height: 1.1em
    display: inline-block
    background-color: white
    color: #690088
  p:nth-child(2)
    font-size: min(1.6em, 5.8vw)

.tarjetas      
  display: grid 
  grid-template-columns: repeat(auto-fit, minmax(180px,1fr))
  margin-top: min(2em, 3vw)
  & > div
    text-align: center
    display: flex
    flex-direction: column
    justify-content: flex-end
    align-items: center
    padding: min(1em, 2vw)
    p 
      margin: 0
      color: white
      font-size: min(1.15em, calc(0.8em + .9vw))
      line-height: 1.1em
  
  & img 
    max-width: 60vw
    width: 80%
  .reloj
    background-color: #5D0472
    p:nth-child(3)
      background-color: #E1A6E8
      color: #360047
      font-size: calc(1.7em + 1vw)
      font-weight: 900
      line-height: 1em
      padding: 5px 10px
  .papeles
    background-color: #87229B
    p:nth-child(2)
      color: #E1A6E8
      font-size: calc(2em + 1vw)
      line-height: 1.5em
      font-weight: 900
    p:nth-child(4)
      background-color: #CC66DC
      color: #FFF100  
      font-size: calc(1.3em + 1vw)
      font-weight: 600
      line-height: 1.2em
  .red
    display: grid
    grid-template-columns: 1fr 1fr
    grid-template-rows: 1fr min-content
    p 
      grid-column: 1 / span 2
      color: #360047
      font-weight: 500
      margin-top: .6em
    .b 
      display: flex
      flex-direction: column
      align-items: center
      height: 100%
      border-bottom: 2px solid
      justify-content: flex-end
      margin: 1em 0
      min-height: 250px
      .barra 
        flex-basis: auto
      .casos 
        color: #360047
        font-weight: 600
        font-size: calc(1.3em + 1vw)
      .fecha 
        color: #FFF100 
  .unocinco
    background-color: #CC66DC

  .intraf
    background-color: #E1A6E8

.pie
  display: grid
  grid-template-columns: repeat(auto-fill, minmax( max(min(370px, 100%), calc(50% - 1em)), 1fr))
  justify-items: center
  margin-top: 2em
  font-size: 0.85em
  line-height: 1.05em
  row-gap: 1em
  column-gap: 1em
  p 
    margin: 0
  img 
    width: 242px



@media only screen and (max-width: 650px) 
  
</style>